import axios from 'axios';

export default function formatValueViaRemoteHttp(apiBaseUrl: string, value: number): Promise<string> {
    return new Promise((resolve, reject) => {
        axios.get(apiBaseUrl + value)
            .then((response: any) => {
                // handle success
                if (!response.data.result) {
                    reject('HTTP response body has no result property. Response: ' + JSON.stringify(response));
                }
                resolve(response.data.result);
            })
            .catch((error) => {
                reject('Error making HTTP requst:' + error);
            });
    });
}
